module.exports = __webpack_public_path__ + "static/img/xssc2.d1211cd8.png";